import { LeftOutlined, CheckOutlined, PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Flex, Form, FormInstance, Input, Row, Select, Space, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { setListSelect, setPagePerfilTaxaImposto, setTaxaImposto } from "../../../../redux/slices/perfilTaxaImposto/perfilTaxaImpostoSlice";
import { atualizarPerfilTaxaImposto, cadastrarPerfilTaxaImposto } from "../../../../services/perfilTaxaImpostoService";
import { TaxaImpostoModel } from "../../../../models/taxaImposto/taxaImpostoModel";
import { buscarTaxaImposto } from "../../../../services/taxaImpostoService";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import EditableCellComponent from "../../../../components/editableCellComponent";

const CadastrarPage = () => {
  //estados globais
  const perfilTaxaImpostoState = useAppSelector((state) => state.perfilTaxaImposto);
  const taxaImpostoState = useAppSelector((state) => state.taxaImposto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [valueImposto, setValueImposto] = useState<number>();

  const EditableContext = React.createContext<FormInstance<any> | null>(null);

  const editar = Object.values(perfilTaxaImpostoState.entity).length !== 0;

  interface EditableRowProps {
    index: number;
  }

  useEffect(() => {
    if (editar) {
      dispatch(setTitle("EDITAR PERFIL DE TAXA DE IMPOSTO"));
      form.setFieldsValue({ ...perfilTaxaImpostoState.entity });
      dispatch(setTaxaImposto(perfilTaxaImpostoState.entity.detalhes));
    } else {
      dispatch(setTitle("NOVO PERFIL DE TAXA DE IMPOSTO"));
      dispatch(setTaxaImposto([]));
      dispatch(setListSelect(taxaImpostoState.list));
      form.setFieldValue("percentual", 0);
    }
  }, [perfilTaxaImpostoState.entity]);

  const submit = (values: any) => {
    delete values.imposto;
    delete values.percentual;
    const perfilTaxaImposto = objetoTaxaImpostoSubmit();
    const newObject = { ...values, perfilTaxaImposto };
    if (editar) {
      dispatch(
        atualizarPerfilTaxaImposto({
          value: {
            ...newObject,
            id: perfilTaxaImpostoState.entity.id,
          },
          busca: perfilTaxaImpostoState.busca,
        })
      );
    } else {
      dispatch(cadastrarPerfilTaxaImposto({ value: newObject, busca: perfilTaxaImpostoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setTitle("PERFIL DE TAXA DE IMPOSTO"));
    dispatch(setPagePerfilTaxaImposto("geral"));
  };

  const objetoTaxaImpostoSubmit = () => {
    const perfilTaxaImposto: any[] = [];
    perfilTaxaImpostoState.listaTaxaImposto.forEach((taxaImposto: TaxaImpostoModel) => perfilTaxaImposto.push({ idTaxaImposto: taxaImposto.id }));
    return perfilTaxaImposto;
  };

  const atualizaFields = async (novaLista: any) => {
    var count = 0;
    novaLista.forEach((taxaImposto: any) => (count += taxaImposto.percentual));
    form.setFieldValue("percentual", count);
    if (novaLista.length !== 0) {
      var options: any[] = [];
      const idsTaxaImposto = novaLista.map((taxaImposto: any) => taxaImposto.id);
      taxaImpostoState.list.forEach((perfilTaxaImposto: any) => !idsTaxaImposto.includes(perfilTaxaImposto.id) && options.push(perfilTaxaImposto));
      await dispatch(setListSelect(options));
    } else {
      await dispatch(setListSelect(taxaImpostoState.list));
    }
  };

  const handleDelete = (key: any) => {
    const newData = perfilTaxaImpostoState.listaTaxaImposto.filter((item: any) => item.id !== key);
    dispatch(setTaxaImposto(newData));

    atualizaFields(newData);
  };

  const handleTaxaImpostoChange = (value: any, option: any) => setValueImposto(option.key);

  const adicionaTaxaImposto = async () => {
    var buscaParams = { ...taxaImpostoState.busca };
    buscaParams.id = valueImposto !== undefined ? valueImposto : null;

    const busca1 = await dispatch(buscarTaxaImposto(buscaParams));

    await dispatch(setTaxaImposto([...perfilTaxaImpostoState.listaTaxaImposto, busca1.payload[0]]));

    await atualizaFields([...perfilTaxaImpostoState.listaTaxaImposto, busca1.payload[0]]);
    form.setFieldValue("imposto", null);
    await dispatch(buscarTaxaImposto({ id: null, pesquisar: null }));
  };

  const handleSave = (row: any) => {
    const newData = [...perfilTaxaImpostoState.listaTaxaImposto];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    dispatch(setTaxaImposto(newData));
  };

  const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const defaultColumns: (ColumnsType[number] & {
    editable?: boolean;
    dataIndex?: string;
  })[] = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a: any, b: any) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ABREVIAÇÃO",
      dataIndex: "abreviacao",
      align: "center" as "center",
      sorter: (a: any, b: any) => a.abreviacao.localeCompare(b.abreviacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "PERCENTUAL/VALOR",
      align: "center" as "center",
      sorter: (a: any, b: any) => {
        const valueA = a.valorFixoImposto ?? a.percentual ?? 0;
        const valueB = b.valorFixoImposto ?? b.percentual ?? 0;
        return valueA - valueB;
      },
      render: (text, record) => {
        const { percentual, valorFixoImposto }: any = record;
        if (valorFixoImposto === null) {
          return percentual ? `${percentual.toFixed(2)}%` : "";
        } else {
          return currencyBRL(valorFixoImposto);
        }
      },
      sortDirections: ["ascend", "descend", "ascend"],
    },

    {
      title: "AÇÕES",
      dataIndex: "operation",
      align: "right" as "right",
      render: (_: any, record: any) => <DeleteOutlined onClick={() => handleDelete(record.id)} style={{ marginRight: "10px", color: "#334155" }} />,
    },
  ];

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCellComponent,
    },
  };

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });

  return (
    <Flex gap={12} vertical>
      <Flex onClick={voltar} className="voltar">
        {"<"} VOLTAR
      </Flex>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12}>
          <Col span={6}>
            <Form.Item
              label="Nome do perfil de taxa de imposto"
              name="denominacao"
              rules={[
                {
                  required: true,
                  message: "Digite a nome do perfil de taxa de imposto",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item label="Percentual" name="percentual">
              <NumericFormat className="ant-input noBoderColor number-input" disabled={true} decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0">
          Impostos associados
        </Divider>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Form.Item
              name="imposto"
              label="Imposto"
              rules={[
                {
                  required: perfilTaxaImpostoState.listaTaxaImposto.length === 0,
                  message: "Selecione um imposto",
                },
              ]}
            >
              <Select
                showSearch
                onChange={handleTaxaImpostoChange}
                placeholder="Selecione um imposto"
                loading={perfilTaxaImpostoState.loading}
                options={perfilTaxaImpostoState.listSelect.map((a: any) => ({
                  value: a.denominacao,
                  label: a.denominacao,
                  key: a.id,
                }))}
                style={{ width: "425px" }}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <Form.Item label=" ">
                <Button className="addButton buttonPrimary" onClick={adicionaTaxaImposto} icon={<PlusCircleOutlined />} disabled={valueImposto === undefined}>
                  ADICIONAR
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Table
              size="small"
              columns={columns as any}
              dataSource={perfilTaxaImpostoState.listaTaxaImposto}
              loading={perfilTaxaImpostoState.loading}
              components={components}
              rowClassName={() => "editable-row"}
              rowKey="id"
              showSorterTooltip={false}
              pagination={{
                showSizeChanger: true,
              }}
              scroll={{ x: 950 }}
            />
          </Col>
        </Row>
        <div>
          <Divider></Divider>
          <Row gutter={12}>
            <Col span={24} className="modalFooter">
              <Space size="middle">
                <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
                  VOLTAR
                </Button>
                <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                  {editar ? "ATUALIZAR" : "SALVAR"}
                </Button>
              </Space>
            </Col>
          </Row>
        </div>
      </Form>
    </Flex>
  );
};

export default CadastrarPage;
